import React, { Component } from 'react';
import './fields.css';
import { Utils } from '../../services';
import GeckoField from './field';

class GeckoFields extends Component {

    // Check if field should be hidden
    isHidden(field) {
        return field.hideWhen ? field.hideWhen() : false;
    }

    renderClasses(field) {
        return Utils.classNames({   
            'form-group col-12': true,
            [field.className]: field.className
        });
    }

    renderStyles(field) {
        let styles = {};

        // Add field width
        if (field.width) styles['flex'] = '0 0 ' + field.width;
        // Add default width
        if (!field.width) styles['flex'] = '0 0 50%';
        // Break onto new line (ALLAN INSISTED ON FLEXBOX AND THIS NO LONGER WORKS!!!)
        //if (field.break) styles['clear'] = 'both';
        return styles;
    }

    renderField(field, i) {
        if (field.render && !this.isHidden(field)) 
        {
            return (
                <div className={this.renderClasses(field)} key={i}>
                    {field.render()}
                </div>
            );
        }

        if (!this.isHidden(field)) {
            return (
                <div className={this.renderClasses(field)} style={this.renderStyles(field)} key={i}>
                    <GeckoField field={field} values={this.props.values} handler={this.props.handler.bind(this)} />
                </div>
            );
        }
        return null;
    }

    submitForm(event) {
        // Stop the form from reloading the page
        event.preventDefault();
        // Fire custom submit handler
        return this.props.submitHandler();
    }

    render() {
        return (
            <form className="gecko-fields" onSubmit={this.submitForm.bind(this)}>
                {this.props.fields.map((field, i) => this.renderField(field, i))}
                <input className="gecko-submit-input" type="submit" value="#" />
            </form>
        );
    }
}

GeckoFields.defaultProps = {
    fields: [],
    values: {},
    handler: () => {},
    submitHandler: () => {}
};

export default GeckoFields;